/**
 * Booking Form Handler
 */

document.addEventListener('DOMContentLoaded', function () {
  const bookingForms = document.querySelectorAll('#booking-form');

  bookingForms.forEach(function (form) {
    const ajaxUrl = form.dataset.ajaxUrl;
    const submitBtn = form.querySelector('button[type="submit"]');
    const btnText = submitBtn.querySelector('.btn__text');
    const btnLoading = submitBtn.querySelector('.btn__loading');
    const errorContainer = form.querySelector('.block-booking-form__error');
    const successContainer = form
      .closest('.block-booking-form')
      .querySelector('.block-booking-form__success');
    const vliegdagSelect = form.querySelector('#vliegdag');
    const aantalSelect = form.querySelector('#aantal_personen');

    // Update aantal options based on available slots
    if (vliegdagSelect && aantalSelect) {
      vliegdagSelect.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        const beschikbaar = parseInt(selectedOption.dataset.beschikbaar) || 5;

        // Update options
        Array.from(aantalSelect.options).forEach(function (option) {
          const value = parseInt(option.value);
          if (value > beschikbaar) {
            option.disabled = true;
            option.textContent = option.value + ' personen (niet beschikbaar)';
          } else {
            option.disabled = false;
            option.textContent =
              value + ' ' + (value === 1 ? 'persoon' : 'personen');
          }
        });

        // Reset to 1 if current selection is now disabled
        if (parseInt(aantalSelect.value) > beschikbaar) {
          aantalSelect.value = '1';
        }
      });
    }

    // Form submission
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      // Hide error
      errorContainer.style.display = 'none';
      errorContainer.innerHTML = '';

      // Show loading state
      btnText.style.display = 'none';
      btnLoading.style.display = 'flex';
      submitBtn.disabled = true;

      try {
        const formData = new FormData(form);

        const response = await fetch(ajaxUrl, {
          method: 'POST',
          body: formData,
        });

        const result = await response.json();

        if (result.success) {
          // Hide form, show success
          form.style.display = 'none';
          successContainer.style.display = 'block';

          // Scroll to success message
          successContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        } else {
          // Show error
          errorContainer.innerHTML = result.data.message;
          errorContainer.style.display = 'block';

          // Scroll to error
          errorContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      } catch (error) {
        console.error('Booking error:', error);
        errorContainer.innerHTML =
          'Er is iets misgegaan. Probeer het later opnieuw.';
        errorContainer.style.display = 'block';
      } finally {
        // Reset button state
        btnText.style.display = 'inline';
        btnLoading.style.display = 'none';
        submitBtn.disabled = false;
      }
    });
  });
});
